import type { PositionItem, PositionOption } from './type';

const mapPositionToOption = (pos: PositionItem): PositionOption => ({
  ...pos,
  value: pos.id,
  label: pos.name,
});

export const mapPositionsToOptions = (
  positions: readonly PositionItem[],
): readonly PositionOption[] => positions.map(mapPositionToOption);
